var styles = {"fontElementMap":"MEyjG","orderedlist":"eWKFL","bulletedlist":"LGfen","listItem":"d7kVU"};

export { styles as s };
//# sourceMappingURL=lists-6e521021.js.map
